import React from 'react'
import { useLocation } from 'react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'

type TProps = {
  children?: React.ReactNode
}

export const AnimationProvider: React.FC<TProps> = ({ children }) => {
  const { pathname } = useLocation()
  return (
    <SwitchTransition mode="out-in">
      <CSSTransition key={pathname} classNames="fade" timeout={150}>
        {children}
      </CSSTransition>
    </SwitchTransition>
  )
}
